import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import { ModalFormInstructions } from '@monorepo/shared/componentsV2/modals/contents/ModalFormInstructions';
import { FormTemplateFieldTypes } from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import { EditFieldForm } from '../EditFieldModal/EditFieldForm';
import { getFieldTypeInline } from '../getFieldTypeDisplay';

type EditNewFieldWizardPageProps = {
  isInDuplicableSection: boolean;
  prefix?: string;
};

export function EditNewFieldWizardPage({
  isInDuplicableSection,
  prefix,
}: EditNewFieldWizardPageProps) {
  const {
    input: { value: fieldType },
  } = useField<FormTemplateFieldTypes>(getFieldNameWithPrefix('type', prefix));

  if (!fieldType) {
    throw new Error('Field type is missing on the add field details form');
  }

  return (
    <>
      <ModalFormInstructions>
        Add details and confirm settings for your{' '}
        <b>{getFieldTypeInline(fieldType)}</b> field.
      </ModalFormInstructions>
      <EditFieldForm
        fieldType={fieldType}
        // net new fields cannot yet have other fields depend on them
        isConditionTriggerField={false}
        conditionalRules={[]}
        isInDuplicableSection={isInDuplicableSection}
        prefix={prefix}
        isEditMode={false}
      />
    </>
  );
}
